import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureHighlights = () => {
  const features = [
    {
      icon: 'FolderOpen',
      title: 'Multi-Bucket Management',
      description: 'Manage multiple S3 buckets from one interface'
    },
    {
      icon: 'Upload',
      title: 'Easy File Upload',
      description: 'Drag and drop files with progress tracking'
    },
    {
      icon: 'Search',
      title: 'Advanced Search',
      description: 'Find files quickly with powerful filters'
    },
    {
      icon: 'Download',
      title: 'Bulk Operations',
      description: 'Download, delete, or move multiple files at once'
    }
  ];

  return (
    <div className="mt-12 pt-8 border-t border-border">
      <h3 className="text-lg font-semibold text-foreground text-center mb-6">
        Powerful Features
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {features?.map((feature, index) => (
          <div key={index} className="flex gap-4">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name={feature?.icon} size={20} color="var(--color-primary)" />
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground mb-1">
                {feature?.title}
              </h4>
              <p className="text-xs text-muted-foreground">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureHighlights;